import { PickerValidDate } from "@mui/x-date-pickers-pro";
import {
  RoadmapDto,
  RoadmapItemDto,
  RoadmapItemSourceType,
} from "../../../../../customer-experience/src/lib/ShiOneClient";

export interface RoadmapItemProps {
  roadmapItemId: string;
  roadmapId: string;
  parentRoadmapItemId?: string;
  id: string;
  name: string;
  status: string;
  owner: string;
  isMilestone: boolean;
  description?: string;
  startDate: Date;
  targetDate: Date;
  createdDate: Date;
  lastModifiedDate: Date;
  open?: boolean;
  subRoadmapItems: RoadmapItems;
  totalCost: number;
  [key: string]:
    | string
    | number
    | boolean
    | undefined
    | Date
    | PickerValidDate
    | RoadmapItems
    | null;
}

const initialRoadmapData = {
  name: "",
};

export const initialRoadmapItemData = {
  roadmapItemId: null,
  roadmapId: "0",
  name: "",
  isMilestone: false,
  roadmapItemOrdinal: 0,
  sourceType: RoadmapItemSourceType.Custom,
  sourceId: "",
  description: "",
  startDate: new Date(),
  targetDate: new Date(),
  createdDate: new Date(),
  lastModifiedDate: new Date(),
  subRoadmapItems: [],
  parentRoadmapItemId: null,
  owner: "",
  isShiHelping: false,
  isDeleted: false,
  costItems: [
    {
      category: "Services",
      subcategory: "Training",
      amount: 0,
    },
    {
      category: "Hardware & Infrastructure",
      subcategory: "Cloud Infrastructure",
      amount: 0,
    },
    {
      category: "Software & Licensing",
      subcategory: "Cloud Software (SaaS)",
      amount: 0,
    },
    {
      category: "Services",
      subcategory: "Managed Services",
      amount: 0,
    },
    {
      category: "Hardware & Infrastructure",
      subcategory: "On-Prem Hardware",
      amount: 0,
    },
    {
      category: "Services",
      subcategory: "Professional Services",
      amount: 0,
    },
    {
      category: "Software & Licensing",
      subcategory: "On-Prem Software",
      amount: 0,
    },
    {
      category: "Support & Maintenance",
      subcategory: "Support & Maintenance",
      amount: 0,
    },
  ],
};

export const initialRoadmapItemState = RoadmapItemDto.fromJS(
  initialRoadmapItemData,
);

export const initialRoadmapState = RoadmapDto.fromJS(initialRoadmapData);

export interface RoadmapItems extends Array<RoadmapItemProps> {}

export interface Roadmap {
  id: string;
  customerId: string;
  name: string;
  description?: string;
  createdDate: Date | null;
  lastModifiedDate: Date | null;
  roadmapItems: RoadmapItems;
  totalCost: number;
}

interface Roadmaps extends Array<Roadmap> {}

export const roadmapExample: Roadmaps = [
  {
    id: "roadmap1",
    customerId: "customer1",
    name: "Security Improvement Plan",
    description: "Test description",
    createdDate: new Date(2024, 9, 15),
    lastModifiedDate: new Date(2025, 1, 27),
    roadmapItems: [
      {
        id: "roadmap1-init1",
        roadmapItemId: "roadmap1-init1",
        roadmapId: "roadmap1",
        name: "Enhance User Protection & Security Awareness",
        status: "In Progress",
        isMilestone: false,
        description: "Test description",
        owner: "Project Manager",
        startDate: new Date(2024, 9, 15),
        targetDate: new Date(2025, 10, 10),
        createdDate: new Date(2024, 8, 15),
        lastModifiedDate: new Date(2025, 1, 27),
        open: false,
        subRoadmapItems: [],
        totalCost: 0.0,
      },
      {
        id: "roadmap1-init2",
        roadmapItemId: "roadmap1-init2",
        roadmapId: "roadmap1",
        name: "Cloud Security Recommendations",
        status: "Upcoming",
        isMilestone: false,
        description: "Test description",
        owner: "SHI",
        startDate: new Date(2025, 6, 12),
        targetDate: new Date(2025, 11, 23),
        createdDate: new Date(2025, 1, 27),
        lastModifiedDate: new Date(2025, 1, 27),
        open: false,
        subRoadmapItems: [],
        totalCost: 0.0,
      },
    ],
    totalCost: 0.0,
  },
];
